import { render, staticRenderFns } from "./JImageDraw.vue?vue&type=template&id=490b886b&scoped=true"
import script from "./JImageDraw.vue?vue&type=script&lang=js"
export * from "./JImageDraw.vue?vue&type=script&lang=js"
import style0 from "./JImageDraw.vue?vue&type=style&index=0&id=490b886b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490b886b",
  null
  
)

export default component.exports